export default __webpack_public_path__ + "static/media/icon-admin.10d7cc36.svg";